module.exports = __webpack_public_path__ + "static/media/icon_arrow_left_grey.4c11ab73.svg";